import { CheckCircle } from "lucide-react";

const RXTControlSystem = () => {
  const controlSystem = [
    {
      title: "ReAX™ JavaScript Platform",
      items: [
        "Powerful JavaScript-based control system with unlimited customization",
        "No limits to control capabilities — fully programmable platform",
        "2D/3D graphics engine for complex visual interfaces",
        "4K30 H.264 streaming decoder for video content",
        "Free Core Studio tool for programming and interface creation"
      ]
    },
    {
      title: "Remote Access & Control",
      items: [
        "Internal web server for remote access on all models",
        "Wireless remote web control via smartphones and computers",
        "Fully customizable interface and functionality",
        "Real-time system monitoring and diagnostics"
      ]
    }
  ];

  return (
    <div className="mb-16">
      <h2 className="text-2xl font-bold mb-8">Control System</h2>
      <div className="grid gap-6 md:grid-cols-2">
        {controlSystem.map((system, index) => (
          <div key={index} className="bg-card rounded-lg p-6 border shadow-sm">
            <h3 className="text-lg font-semibold mb-3 text-[#069E50]">{system.title}</h3>
            <ul className="space-y-2">
              {system.items.map((item, itemIndex) => (
                <li key={itemIndex} className="flex items-start gap-2">
                  <CheckCircle className="h-4 w-4 text-[#069E50] mt-0.5 flex-shrink-0" />
                  <span className="text-sm text-muted-foreground">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RXTControlSystem;
